import { useState, useEffect } from 'react';

export function usePathnameListener(): string {
  const [pathname, setPathname] = useState(window.location.pathname);

  useEffect(() => {
    const updatePath = (): void => setPathname(window.location.pathname);

    window.addEventListener('popstate', updatePath);

    // Patch pushState and replaceState to also trigger update
    const origPushState = window.history.pushState;
    // eslint-disable-next-line func-names
    window.history.pushState = function (...args) {
      origPushState.apply(this, args);
      updatePath();
    };

    return () => {
      window.removeEventListener('popstate', updatePath);
      window.history.pushState = origPushState;
    };
  }, []);

  return pathname;
}
